import { render, staticRenderFns } from "./SharingEntryInherited.vue?vue&type=template&id=c58e421a&scoped=true&"
import script from "./SharingEntryInherited.vue?vue&type=script&lang=js&"
export * from "./SharingEntryInherited.vue?vue&type=script&lang=js&"
import style0 from "./SharingEntryInherited.vue?vue&type=style&index=0&id=c58e421a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58e421a",
  null
  
)

export default component.exports